import { DefaultAttributeValue } from '@source-components-react/types';
import {
  TEXT_SHOW_LESS_LABEL_ATTRIBUTE,
  TEXT_SHOW_MORE_AFTER_ATTRIBUTE,
  TEXT_SHOW_MORE_LABEL_ATTRIBUTE,
} from './text-attributes';

export const DEFAULT_CONTENT_TEXT =
  'This is a text block. Click to edit and add your own content.';

export const defaultAttributeValues: DefaultAttributeValue[] = [
  {
    name: 'content-text-3-resolutions',
    defaultValues: {
      all: DEFAULT_CONTENT_TEXT,
    },
  },
  {
    name: 'enclosing-tag-3-resolutions',
    defaultValues: {},
  },
  {
    name: 'links-3-resolutions',
    defaultValues: {},
  },
  {
    name: 'inline-styles-3-resolutions',
    defaultValues: {},
  },
  {
    name: TEXT_SHOW_MORE_AFTER_ATTRIBUTE,
    defaultValues: {},
  },
  {
    name: TEXT_SHOW_MORE_LABEL_ATTRIBUTE,
    defaultValues: {},
  },
  {
    name: TEXT_SHOW_LESS_LABEL_ATTRIBUTE,
    defaultValues: {},
  },
];
